export const isInNativeWebView = (): boolean =>
  typeof window !== "undefined" && Boolean(window.ReactNativeWebView);
